module.exports = __webpack_public_path__ + "img/istay-white-text.ecc34fb9.png";